import { AnimatePresence, motion } from 'framer-motion';

function FinishScreen({
  questionPoint,
  maxPossiblePoints,
  highscore,
  dispatch,
  brandColor,
  triviaQuizSettings,
  brandFont,
}) {
  const percentage = (questionPoint / maxPossiblePoints) * 100;

  // let emoji;
  // if (percentage === 100) emoji = "🥇";
  // if (percentage >= 80 && percentage < 100) emoji = "🎉";
  // if (percentage >= 50 && percentage < 80) emoji = "🙃";
  // if (percentage >= 0 && percentage < 50) emoji = "🤨";
  // if (percentage === 0) emoji = "🤦‍♂️";

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        // height: "100vh",
        textAlign: 'center',
      }}
    >
      <AnimatePresence mode="wait">
        <motion.div
          //className="video-container"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 2 }}
        >
          <img
            src={triviaQuizSettings?.promoPageCenterLogo?.fileUrl}
            alt="Logo"
            style={{
              marginBottom: '2vw',
              display: triviaQuizSettings?.promoPageCenterLogo?.enabled ? 'block' : 'none',
              width: '55vw',
              // height: "130px",
            }}
          />
        </motion.div>
      </AnimatePresence>

      <p style={{ fontSize: '5vw', marginBottom: '2vw', fontFamily: brandFont }}>
        Your score: <strong style={{ fontFamily: brandFont }}>{`${Math.ceil(percentage)}%`}</strong>{' '}
        ({`${questionPoint} out of ${maxPossiblePoints}`})
      </p>

      <AnimatePresence mode="wait">
        <motion.div
          //className="video-container"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 2 }}
        >
          <img
            src={triviaQuizSettings?.promoPageCenterBelowLogo?.fileUrl}
            alt="Logo"
            style={{
              marginTop: '2vw',
              display: triviaQuizSettings?.promoPageCenterBelowLogo?.enabled ? 'block' : 'none',
              width: '55vw',
              // height: "130px",
            }}
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
}

export default FinishScreen;
